import React, { Component } from 'react'

class ScalingResults extends Component {
  render () {
    const votes = !this.props.votes ? 1 : this.props.votes.length === 0 ? 1 : this.props.votes.length
    const oneVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 1).length
    const twoVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 2).length
    const threeVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 3).length
    const fourVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 4).length
    const fiveVotes = !this.props.votes ? 0 : this.props.votes.filter(v => v.vote === 5).length

    return (
      <div className='vote-results-container scaling-results-container'>
        <div className='vote-results'>
          {oneVotes} vote{oneVotes === 1 ? '' : 's'} <span>({Math.floor((oneVotes / votes) * 100)}%)</span>
        </div>
        <div className='vote-results'>
          {twoVotes} vote{twoVotes === 1 ? '' : 's'} <span>({Math.floor((twoVotes / votes) * 100)}%)</span>
        </div>
        <div className='vote-results'>
          {threeVotes} vote{threeVotes === 1 ? '' : 's'} <span>({Math.floor((threeVotes / votes) * 100)}%)</span>
        </div>
        <div className='vote-results'>
          {fourVotes} vote{fourVotes === 1 ? '' : 's'} <span>({Math.floor((fourVotes / votes) * 100)}%)</span>
        </div>
        <div className='vote-results'>
          {fiveVotes} vote{fiveVotes === 1 ? '' : 's'} <span>({Math.floor((fiveVotes / votes) * 100)}%)</span>
        </div>
      </div>
    )
  }
}

export default ScalingResults



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/results/ScalingResults.js